import React, { Fragment, useEffect, useRef, useState } from "react"
import { toast } from "react-toastify"

import {
  approveStockTransferRequest,
  editApprovedStockTransferRequest,
  rejectStockTransferRequest
} from "services"
import { Button, ConfirmationModal } from "components"
import classes from "./StrrtrmFooter.module.scss"

const StrrtrmFooter = (props) => {
  const {
    responseMessage,
    acceptedItems,
    setShowStockTransferRespondeModal,
    stockTransferRequest,
    setStockTransferRequests
  } = props

  const [sending, setSending] = useState(false)
  const [openApproveConfirmationModal, setOpenApproveConfirmationModal] = useState(false)
  const [openRejectConfirmationModal, setOpenRejectConfirmationModal] = useState(false)
  const [openEditApproveConfirmationModal, setOpenEditApproveConfirmationModal] = useState(false)

  const unmount = useRef(false)

  const handleEditApprove = async () => {
    setSending(true)

    const items =
      acceptedItems.map(acceptedItem => ({
        foodId: acceptedItem.foodId,
        optionId: acceptedItem.optionId,
        acceptedQuantity: Number(acceptedItem.acceptedQuantity)
      }))

    try {
      const response =
        await editApprovedStockTransferRequest(
          stockTransferRequest._id,
          {
            responseMessage,
            acceptedItems: items
          }
        )

      if (unmount.current) return

      setStockTransferRequests(prev =>
        prev.map(str =>
          str._id === response._id
            ? { ...str, ...response }
            : str
        )
      )

      setShowStockTransferRespondeModal(false)

      setOpenEditApproveConfirmationModal(false)

      toast.success("ویرایش انجام شد")
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error("ویرایش انجام نشد")
    }
  }

  const handleApprove = async () => {
    setSending(true)

    const items =
      acceptedItems.map(acceptedItem => ({
        foodId: acceptedItem.foodId,
        optionId: acceptedItem.optionId,
        acceptedQuantity: Number(acceptedItem.acceptedQuantity)
      }))

    try {
      const response =
        await approveStockTransferRequest(
          stockTransferRequest._id,
          {
            responseMessage,
            acceptedItems: items
          }
        )

      if (unmount.current) return

      setStockTransferRequests(prev =>
        prev.map(str =>
          str._id === response._id
            ? { ...str, ...response }
            : str
        )
      )

      setShowStockTransferRespondeModal(false)

      setOpenApproveConfirmationModal(false)
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error("عملیات انجام نشد")
    }
  }

  const handleReject = async () => {
    setSending(true)

    try {
      const response =
        await rejectStockTransferRequest(
          stockTransferRequest._id,
          { responseMessage }
        )

      if (unmount.current) return

      setStockTransferRequests(prev =>
        prev.map(str =>
          str._id === response._id
            ? { ...str, ...response }
            : str
        )
      )

      setShowStockTransferRespondeModal(false)

      setOpenRejectConfirmationModal(false)
    } catch (err) {
      console.log(err)

      setSending(false)

      toast.error("عملیات انجام نشد")
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const disabledApproveButton =
    acceptedItems.every(acceptedItem =>
      acceptedItem.acceptedQuantity === "0" ||
      acceptedItem.acceptedQuantity === ""
    )

  const editMode =
    stockTransferRequest.stockTransferStatus === "approved"

  return (
    <Fragment>
      {editMode
        ?
        <div className={classes["footer"]}>
          <Button
            disabled={disabledApproveButton}
            color="success"
            onClick={() => setOpenEditApproveConfirmationModal(true)}
          >
            ویرایش پاسخ
          </Button>
        </div>
        :
        <div className={classes["footer"]}>
          <Button
            disabled={disabledApproveButton}
            color="success"
            onClick={() => setOpenApproveConfirmationModal(true)}
          >
            قبول در خواست
          </Button>
          <Button
            className={classes["button"]}
            color="danger"
            onClick={() => setOpenRejectConfirmationModal(true)}
          >
            رد درخواست
          </Button>
        </div>
      }
      <ConfirmationModal
        title="آیا می خواهید این پاسخ را ویرایش کنید ؟"
        show={openEditApproveConfirmationModal}
        onConfirm={handleEditApprove}
        onHide={() => setOpenEditApproveConfirmationModal(false)}
        loading={sending}
      />
      <ConfirmationModal
        title="آیا می خواهید این درخواست را قبول کنید ؟"
        show={openApproveConfirmationModal}
        onConfirm={handleApprove}
        onHide={() => setOpenApproveConfirmationModal(false)}
        loading={sending}
      />
      <ConfirmationModal
        title="آیا می خواهید این درخواست را رد کنید ؟"
        show={openRejectConfirmationModal}
        onConfirm={handleReject}
        onHide={() => setOpenRejectConfirmationModal(false)}
        loading={sending}
      />

    </Fragment>
  )
}

export default StrrtrmFooter